import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { XCircle, ArrowLeft, HelpCircle } from 'lucide-react'
import { Button } from '../../components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card'
import Page from '../../components/page/page'

export const SubscriptionCancelled: FC = () => {
  const navigate = useNavigate()

  const handleGoBack = () => {
    navigate('/')
  }

  const handleRetry = () => {
    navigate('/#pricing')
  }

  return (
    <Page title="Checkout Cancelled" hideNavbar={false}>
      <div className="flex items-center justify-center min-h-[60vh] p-6">
        <Card className="max-w-2xl w-full border-2 border-neutral-300 dark:border-neutral-700">
          <CardHeader className="text-center pb-4">
            <div className="flex justify-center mb-4">
              <div className="w-20 h-20 rounded-full bg-neutral-100 dark:bg-neutral-800 flex items-center justify-center">
                <XCircle className="w-10 h-10 text-neutral-500 dark:text-neutral-400" />
              </div>
            </div>
            <CardTitle className="text-3xl font-bold text-neutral-900 dark:text-neutral-100">
              Checkout Cancelled
            </CardTitle>
            <CardDescription className="text-lg mt-2">
              Your subscription checkout was not completed
            </CardDescription>
          </CardHeader>

          <CardContent className="space-y-6">
            {/* Info Message */}
            <div className="bg-neutral-100 dark:bg-neutral-800 border border-neutral-300 dark:border-neutral-700 rounded-lg p-4 text-center">
              <p className="text-neutral-700 dark:text-neutral-300">
                No charges have been made to your account. You can return to the pricing page to try again whenever you're ready.
              </p>
            </div>

            {/* Help Section */}
            <div>
              <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-100 mb-3 flex items-center gap-2">
                <HelpCircle className="w-5 h-5" />
                Need Help?
              </h3>
              <ul className="space-y-2 text-sm text-neutral-700 dark:text-neutral-300">
                <li className="flex items-start gap-2">
                  <div className="w-1.5 h-1.5 rounded-full bg-neutral-400 mt-2" />
                  <span>If you encountered an error during checkout, please try again</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-1.5 h-1.5 rounded-full bg-neutral-400 mt-2" />
                  <span>Contact our support team if you continue to experience issues</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-1.5 h-1.5 rounded-full bg-neutral-400 mt-2" />
                  <span>You can always start with the Basic plan and upgrade later</span>
                </li>
              </ul>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 pt-4">
              <Button
                onClick={handleRetry}
                variant="primary"
                size="lg"
                className="flex-1"
              >
                Try Again
              </Button>
              <Button
                onClick={handleGoBack}
                variant="outline"
                size="lg"
                className="flex-1"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Dashboard
              </Button>
            </div>

            {/* Support Info */}
            <div className="text-center text-sm text-neutral-500 dark:text-neutral-400 pt-4 border-t dark:border-neutral-700">
              <p>Have questions? Contact us at support@inventorysumo.com</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </Page>
  )
}

export default SubscriptionCancelled
